var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-sale", attrs: { id: "app_sale" } }, [
    _c("h3", { staticClass: "app-sale-title" }, [
      _vm._v(
        "\n\t\t" +
          _vm._s(_vm.getConstants("BOXCRYPTOR_LANDING_SALE_TITLE")) +
          "\n\t"
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "app-sale-description" }, [
      _vm._v(
        "\n\t\t" +
          _vm._s(_vm.getConstants("BOXCRYPTOR_LANDING_SALE_SUBTITLE")) +
          "\n\t"
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "app-sale-content dp-f" },
      [_c("EagleProTap"), _vm._v(" "), _c("EagleAdvanceTap")],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }